export default function Card2Icon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path d="M2.736 3.75c-.107.499-.146 1.163-.146 1.612 0 3.73 2.231 6.191 5.64 6.191 1.66 0 2.641-.727 3.149-1.274.395.566.61 1.162.86 1.958.077.244.253.352.453.352.396 0 .718-.342.718-.801 0-.689-1.006-1.895-1.523-2.373-2.202-2.046-5.537-.81-6.348-3.003-.059-.152.098-.259.23-.127 1.699 1.782 3.95.303 6.044 2.222.21.185.46.097.499-.123.024-.136.039-.36.039-.59 0-2.403-1.66-3.643-4.107-3.643-.8 0-1.738.205-2.466.205-.771 0-1.64-.054-2.353-.796-.244-.249-.6-.19-.689.19z" fill="#383A3D" fillRule="nonzero" />
      </g>
    </svg>
  );
};
